/*
 * Copyright 2025 Intuition Robotics ltd
 */
import * as React from "react";
import {BaseComponent} from "@intuitionrobotics/thunderstorm/frontend";
import {OnUsersUpdated} from "@modules/UsersModule";
import {NoPermissionsPanel} from "./NoPermissionsPanel";
import {RenderHome} from "./RenderHome";
import {getTabPermissions} from "@modules/utils";

// No need to add this in the array


export class Page_Home
    extends BaseComponent
    implements OnUsersUpdated {

    constructor(props: {}) {
        super(props);
    }

    __onUsersUpdated() {
        this.forceUpdate();
    }


    render() {
        if (getTabPermissions() === undefined)
            return <NoPermissionsPanel/>

        return <RenderHome/>
    }
}
